import { CornerInfo, DrawingShape } from '~/core/models';

const containsDiagonalCorner = (cornerInfo: CornerInfo): boolean =>
  cornerInfo.diagonalLength !== undefined;

export const isDiagonalCornerRemoveEnabled = (
  drawingShapes: DrawingShape[]
): boolean =>
  drawingShapes.some((shape) =>
    Object.values(shape.cornerMap).some((cornerInfo) =>
      containsDiagonalCorner(cornerInfo)
    )
  );

const hasInteriorDiagonalCorner = (radiusInfo: CornerInfo): boolean =>
  !!(radiusInfo.isVisibleInCanvas && radiusInfo.angle && radiusInfo.angle < 0);

export const checkInteriorDiagonalCornerInShapes = (
  drawingShapes: DrawingShape[]
): boolean =>
  drawingShapes.some((drawingShape) =>
    Object.values(drawingShape.cornerMap).some(hasInteriorDiagonalCorner)
  );
